import React from 'react';
import type { ClientSearchResult } from '../../services/clientService';

interface ClientSuggestionItemProps {
  client: ClientSearchResult;
  isSelected: boolean;
  onClick: () => void;
}

export const ClientSuggestionItem: React.FC<ClientSuggestionItemProps> = ({
  client,
  isSelected,
  onClick,
}) => {
  // Construire l'adresse complète
  const addressParts = [];
  if (client.address) addressParts.push(client.address);
  if (client.postal_code) addressParts.push(client.postal_code);
  if (client.city) addressParts.push(client.city);
  const fullAddress = addressParts.join(', ');

  return (
    <div
      onClick={onClick}
      className={`py-1.5 px-3 cursor-pointer border-b border-gray-200 last:border-b-0 transition-colors duration-150 ${
        isSelected
          ? 'bg-blue-500 text-white border-blue-600'
          : 'bg-yellow-50 hover:bg-blue-50 text-gray-900'
      }`}
    >
      <div className="flex items-center gap-2 min-w-0">
        <div
          className={`font-medium truncate uppercase flex-shrink-0 ${
            isSelected ? 'text-white' : 'text-gray-900'
          }`}
        >
          {client.full_name}
        </div>
        {fullAddress && (
          <>
            <span className={`flex-shrink-0 ${isSelected ? 'text-blue-100' : 'text-gray-400'}`}>
              -
            </span>
            <div
              className={`text-sm truncate uppercase flex-1 min-w-0 ${
                isSelected ? 'text-blue-50' : 'text-gray-600'
              }`}
            >
              {fullAddress}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
